var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-wrapper"},[_c('div',{staticClass:"subpage__inner"},[_c('SubpageNav',{attrs:{"links":_vm.links}}),_c('transition',{attrs:{"name":"fade-up"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }